<script setup lang="ts">
import {computed, onMounted, PropType, ref, useTemplateRef} from "vue";
import {ICellEditorParams} from "ag-grid-community";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";

const props = defineProps({
  params: {
    type: Object as PropType<ICellEditorParams>,
    required: true
  },
});
const password = ref(props.params.value || '');
const isHidden = ref(true);
const inputType = computed(() => isHidden.value ? 'password' : 'text');
const input = useTemplateRef<HTMLInputElement>("input");

function getValue() {
  return password.value;
}

onMounted(() => {
  if (input.value) {
    setTimeout(() => {
      input.value!.focus();
      input.value?.select();
      if (props.params?.eventKey?.length === 1) {
        password.value = props.params?.eventKey;
      }
    })
  }
});

function namaUpdateValue(value: string) {
  password.value = value;
}

function onKeyDown(event: KeyboardEvent) {
  if (AGGridUtils.isBulkAction(event)) {
    namaUpdateValue(getValue());
    AGGridUtils.dispatchBulkEventFor(input);
  }
  else {
    if (event.key === 'F2') {
      props.params?.api.stopEditing();
    }
  }
}

defineExpose({getValue, namaUpdateValue});
</script>

<template>
  <div class="tw-w-full tw-h-full tw-flex tw-items-center tw-pe-1.5" ref="div">
    <input ref="input" :type="inputType" class="tw-w-full tw-grow tw-border-none tw-bg-transparent focus:tw-ring-0" v-model="password"
           @keydown="onKeyDown"/>
    <q-icon :name="isHidden?'visibility':'visibility_off'" size="20px" @click="isHidden = !isHidden"/>
  </div>
</template>

<style scoped>

</style>
